import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import {
  PushNotificationDeviceCreateRequestType,
  PushNotificationDeviceCreateResponseType,
} from "@sellar-io/api-v2/types";

export const usePushNotificationDeviceCreate = () => {
  const queryClient = useQueryClient();
  const { user } = useFirebaseUser();
  const { business } = useSellarCurrentBusiness();

  return useMutation({
    mutationFn: (data: PushNotificationDeviceCreateRequestType) =>
      apiV2Request({
        user,
        business,
        method: "post",
        path: `push-notification/devices`,
        data,
      }).then(
        (data) =>
          apiV2AssertResponse(data)
            .data as PushNotificationDeviceCreateResponseType,
      ),

    onSuccess: (response) => {
      queryClient.invalidateQueries({
        queryKey: [user?.uid, ServerStateKeys.NotificationToken],
      });
      queryClient.invalidateQueries({
        queryKey: [user?.uid, ServerStateKeys.NotificationToken, response.id],
      });
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.NotificationToken],
      });
    },
  });
};
